import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AlliesService {

  private api = 'assets/content/allies.json'
  itemsProducts;
  

  constructor(private http: HttpClient) {
    this.itemsProducts = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json'})
    };
  }

  getItems(): any{
    return this.http.get(`${this.api}`,this.itemsProducts).pipe();
  }
}
